
import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { Manager } from 'src/app/shared/models/manager.model';
import { ManagerDealer } from '../../models/manager-dealer.model';

@Injectable({ providedIn: 'root' })
export class ManagerService {
    constructor(private dataService: DataService) { }

    public get() {
        return this.dataService.get<Result<Manager>>('manager');
    }

    public getActive() {
        return this.dataService.get<Result<Manager>>('manager/active');
    }
    
    public getDealers(user:string) {
        return this.dataService.get<Result<Manager>>('manager/' + user + '/dealers');
    }

    public deleteDealer(dealerCod:string) {
        return this.dataService.delete<Result<any>>('manager/dealer/' + dealerCod);
    }

    public delete(cod: number) {
        return this.dataService.delete<Result<any>>('manager/' + cod.toString());
    }

    public insert(user: String) {
        return this.dataService.post<Manager>('manager', user);
    }

    public insertDealer(dealerManager: ManagerDealer) {
        return this.dataService.post<ManagerDealer>('manager/dealer', dealerManager);
    }

    public updateDealer(dealerManager: ManagerDealer) {
        return this.dataService.put<ManagerDealer>('manager/dealer', dealerManager);
    }
}
